var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickwitLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 262 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-143.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_horizontal",
    transform: "translate(143.000000, 208.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2947,37.256 L83.5502,32.776 C81.4228,32.389 80.1335,31.841 79.1666,30.906 C82.003,28.747 83.6791,25.588 83.6791,21.849 C83.6791,14.951 77.8773,9.891 69.7869,9.891 C61.6965,9.891 55.8624,14.951 55.8624,21.849 C55.8624,28.747 61.6965,33.807 69.7869,33.807 C70.9795,33.807 72.1399,33.71 73.2358,33.485 C74.6218,35.193 77.5227,36.676 80.2947,37.256 Z M69.7869,15.37 C74.0416,15.37 77.2326,17.884 77.2326,21.849 C77.2326,25.814 74.0416,28.328 69.7869,28.328 C65.5322,28.328 62.3412,25.814 62.3412,21.849 C62.3412,17.884 65.5322,15.37 69.7869,15.37 Z",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5697,33.775 C107.499,33.775 111.85,29.746 111.85,23.106 L111.85,10.277 L105.533,10.277 L105.533,22.494 C105.533,26.2 103.599,28.295 99.5697,28.295 C95.5407,28.295 93.6067,26.2 93.6067,22.494 L93.6067,10.277 L87.2892,10.277 L87.2892,23.106 C87.2892,29.746 91.6405,33.775 99.5697,33.775 Z",
    id: "Fill-2",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#000000",
    points: "116.492 33.42 122.8096 33.42 122.8096 10.277 116.492 10.277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.871,21.849 C126.871,28.747 132.64,33.807 140.698,33.807 C147.145,33.807 151.625,30.906 153.398,26.233 L147.628,23.654 C146.726,26.361 144.373,28.328 140.698,28.328 C136.573,28.328 133.317,25.814 133.317,21.849 C133.317,17.884 136.573,15.37 140.698,15.37 C144.373,15.37 146.726,17.336 147.628,20.044 L153.398,17.465 C151.625,12.792 147.145,9.891 140.698,9.891 C132.64,9.891 126.871,14.951 126.871,21.849 Z",
    id: "Fill-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#000000",
    points: "163.293 10.277 156.976 10.277 156.976 33.42 163.293 33.42 163.293 27.651 167.419 23.944 175.445 33.42 183.471 33.42 171.964 19.883 182.665 10.277 174.059 10.277 163.293 20.044"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#000000",
    points: "199.877 10.277 195.171 25.523 190.111 10.277 183.535 10.277 191.336 33.42 198.105 33.42 202.811 18.271 207.484 33.42 214.285 33.42 222.086 10.277 215.704 10.277 210.611 25.523 205.937 10.277"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#000000",
    points: "225.309 33.42 231.6266 33.42 231.6266 10.277 225.309 10.277"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#000000",
    points: "261.474 15.628 261.474 10.277 235.688 10.277 235.688 15.628 245.422 15.628 245.422 33.42 251.739 33.42 251.739 15.628"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#FF0026",
    points: "10.1812 5.177 24.7219 15.741 28.4826 10.565 13.9419 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#FF0026",
    points: "1.656 21.275 19.0169 16.623 17.3609 10.443 -7.46069873e-14 15.095"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#FF0026",
    points: "8.8107 37.983 16.1213 21.564 10.2763 18.961 2.9657 35.381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#FF0026",
    points: "26.2769 43.019 18.1169 27.005 12.4161 29.91 20.5761 45.924"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#FF0026",
    points: "41.119 32.479 23.5383 28.742 22.2081 35.001 39.7888 38.738"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#FF0026",
    points: "42.2995 14.312 28.3316 25.623 32.3582 30.596 46.3261 19.284"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#FF0026",
    points: "28.5117 20.24 34.9099 20.24 34.9099 2.2668 28.5117 2.2668"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickwitLogo);
export default __webpack_public_path__ + "static/media/quickwit-logo.918fb8ce6ac9c06d8c3111246f4a9420.svg";
export { ForwardRef as ReactComponent };